<template>
  <div>
    <!-- Button to show the modal -->
    <button class="btn btn-sm btn-alt-primary" @click="showModal">
      <i class="fa fa-solid fa-plus me-1"></i> {{ $t('button_add_account') }}
    </button>

    <!-- Modal -->
    <div v-if="modalVisible" class="modal fade show d-block" id="accountCreationModal" tabindex="-1"
      aria-labelledby="accountCreationModalLabel" aria-hidden="true" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="block-rounded block-transparent mb-0 block">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ $t('button_add_account') }}</h3>
              <div class="block-options">
                <button type="button" class="btn-block-option" @click="closeModal">
                  <i class="fa fa-fw fa-times"></i>
                </button>
              </div>
            </div>
            <div class="block-content mb-4">
              <div class="mb-3">
                <label class="form-label">{{ $t('input_account_name') }}</label>
                <input v-model="form.title" type="text" class="form-control" required />
              </div>
              <div class="mb-3">
                <label class="form-label">{{ $t('input_account_type') }}</label>
                <select v-model="form.type" class="form-select" required>
                  <option value="" disabled>{{ $t('placeholder_select_account_type') }}</option>
                  <option v-for="type in accountTypes" :key="type._id" :value="type._id">
                    {{ type.title_ar }}
                  </option>
                </select>
              </div>
            </div>
            <div class="block-content block-content-full bg-body text-end">
              <button type="button" class="btn btn-sm btn-alt-secondary me-1" @click="closeModal">
                {{ $t('button_cancel') }}
              </button>
              <button type="button" class="btn btn-sm btn-primary" @click="submitForm">
                {{ $t('button_submit') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, withKeys, onMounted } from 'vue';
import axios from 'axios';

const modalVisible = ref(false);
const form = ref({
  title: '',
  type: '',
});

const accountTypes = ref([]);

const emit = defineEmits(['account-created']);

const showModal = () => {
  modalVisible.value = true;
};

const closeModal = () => {
  modalVisible.value = false;
  resetForm();
};

const resetForm = () => {
  form.value = {
    title: '',
    type: '',
    account_number: '',
    initial_balance: 0,
  };
};

const submitForm = () => {
  if (!form.value.title || !form.value.type) {
    Swal.fire({
      icon: 'warning',
      title: 'Warning',
      text: 'Please fill in all required fields',
    });
    return;
  }

  createAccount();
};

const createAccount = async () => {
  try {
    const response = await axios.post('/accounts/post', form.value, {
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
      },
    });

    if (response.data.status === 'success') {
      emit('account-created', response.data.account);
      closeModal();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        showConfirmButton: false,
        timer: 1500,
        text: response.data.message,
      })

    } else {
      Swal.fire({
        icon: 'danger',
        title: 'Error',
        text: response.data.message,
      })
    }
  } catch (error) {
    Swal.fire({
      icon: 'danger',
      title: 'Error',
      text: error.response?.data?.message || 'An error occurred while creating the account.',
    });
    console.error('Account creation error:', error);
  }
};

const getAccountTypes = async () => {
  try {
    const response = await axios.get('/accounts/get-account-types');
    accountTypes.value = response.data;
  } catch (error) {
    console.error('Error fetching account types:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to load account types',
    });
  }
};

onMounted(() => {
  getAccountTypes();
});

</script>

<style scoped>
.modal {
  overflow-y: auto;
}

.modal-content {
  margin-top: 100px;
}
</style>